import { shouldLimitAccess } from "./shouldLimitAccess";

export const shouldShowContent = ({
  active,
  content,
  hasPermission,
  permissions
}) => {
  return !shouldLimitAccess({ active, content }) || hasPermission(permissions);
};
